import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRsg = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 114 114",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 57,
			cy: 57,
			r: 48,
			fill: "#050505",
			stroke: "#fff",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("text", {
			x: 57,
			y: 66,
			fill: "#fff",
			fontFamily: "Arial, Helvetica, sans-serif",
			fontSize: 31,
			fontWeight: 800,
			textAnchor: "middle",
			children: "RSG"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 37,
			y: 75,
			width: 40,
			height: 5,
			rx: 1,
			fill: "#00a991"
		})
	]
});
export default SvgRsg;
